/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  SetSpendCapRequestBody,
  SetSpendCapRequestBody$Outbound,
  SetSpendCapRequestBody$outboundSchema,
} from "../components/setspendcaprequestbody.js";

export type SetSpendCapSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type SetSpendCapRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  setSpendCapRequestBody: SetSpendCapRequestBody;
};

/** @internal */
export type SetSpendCapSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const SetSpendCapSecurity$outboundSchema: z.ZodMiniType<
  SetSpendCapSecurity$Outbound,
  SetSpendCapSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function setSpendCapSecurityToJSON(
  setSpendCapSecurity: SetSpendCapSecurity,
): string {
  return JSON.stringify(
    SetSpendCapSecurity$outboundSchema.parse(setSpendCapSecurity),
  );
}

/** @internal */
export type SetSpendCapRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  SetSpendCapRequestBody: SetSpendCapRequestBody$Outbound;
};

/** @internal */
export const SetSpendCapRequest$outboundSchema: z.ZodMiniType<
  SetSpendCapRequest$Outbound,
  SetSpendCapRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    setSpendCapRequestBody: SetSpendCapRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      setSpendCapRequestBody: "SetSpendCapRequestBody",
    });
  }),
);

export function setSpendCapRequestToJSON(
  setSpendCapRequest: SetSpendCapRequest,
): string {
  return JSON.stringify(
    SetSpendCapRequest$outboundSchema.parse(setSpendCapRequest),
  );
}
